window.autoHeightSlider = function(slider) {
    var activeSlideHeight = slider.find('.owl-item.active').outerHeight(true)
    slider.height(activeSlideHeight)
}

if ( /#step-[0-9]/.test(location.hash) ) location.hash = ''

var lastCarousel    = 0;
var firstAutoReload = true;


$v = $('.js-owl-carousel:not(.carousel-advice)').each(function(e) {
    var $slider         = $(this)
    var padding         = $slider.data('padding')
    var dragging        = $slider.data('nodrag') ? false : true
    var $sliderControls = $slider.parent().find('.js-slider-controls')
    var $navContainer   = $sliderControls.find('.js-slider-nav')
    var $dotsContainer  = $sliderControls.find('.js-slider-dots')
    var autosize        = $slider.data('autosize')
    var $maps           = $slider.find('.js-google-maps')

    // Mobile
    var itemsOnMobile = $slider.data('items-mobile')
    var slideOnMobile = $slider.data('slide-mobile')
    var marginMobile  = padding ? -20 : 40
    var paddingMobile = padding ? 20 : 0

    // Desktop
    var itemsOnDesktop = $slider.data('items-desktop')
    var slideOnDesktop = $slider.data('slide-desktop')
    var marginDesktop  = padding ? 70 : 40
    var paddingDesktop = padding ? 120 : 0

    // Variable type slider
    if($slider.hasClass('carousel-advice')){
        breakpoint = 769;
    }else{
        breakpoint = 740;
    }
    
    
    var sliderStartPosition = $('#slider_slide_start').length > 0 ? $('#slider_slide_start').val() : 'URLHash'
    
    $w = $slider.owlCarousel({
        URLhashListener: true,
        startPosition  : sliderStartPosition,
        nav            : true,
        dots           : true,
        mouseDrag      : dragging,
        touchDrag      : dragging,
        navText        : '',
        navContainer   : $navContainer,
        dotsContainer  : $dotsContainer,
        // autoHeight     : true,
        onInitialized : function () {
            //changeProgressBar()
            autosize ? autoHeightSlider($slider) : null
            //shouldStretch()
        },
        onTranslated : function (e) {
            var currentStep = e.item.index + 1;
            var realStep = location.hash ? (typeof location.hash.match(/\d+/)[0] !== "undefined" ? location.hash.match(/\d+/)[0] : 1) : 1;
            //changeProgressBar();
            autosize ? autoHeightSlider($slider) : null;
            //shouldStretch();
            //hideErrorMsg($slider);

            if (currentStep == 1) {
                virtualPageURL = window.location.pathname;
            } else {
                virtualPageURL = window.location.pathname + "step-" + realStep + "/";
            }

             /* Pour empecher au maximum un double envoie de données provenant du meme step
            sur analytics (principalement provoque lors des derniere etapes) */

            // if (! (currentStep == lastCarousel)) {
            //     kinougarde_tracking({
            //         "event" : "VirtualPageview",
            //         "virtualPageURL" : virtualPageURL,
            //         "virtualPageTitle" : document.title + " - STEP " + realStep
            //     });
            // }
            // console.log((!(currentStep == lastCarousel)), "step-" + realStep);
            lastCarousel = currentStep; 
            
            /* ----------------------------------------------------  */

            if (googleMapsLoaded && $maps.length) {
                google.maps.event.trigger($maps.get(0), "resize")
            }

            // if ($slider.closest('.js-steps').length) {
            //     $('html, body').animate({
            //         scrollTop: $('html, body').offset().top
            //     }, 'slow');
            // }
        },
        onResized : function () {
            autosize ? autoHeightSlider($slider) : null
            //shouldStretch()
        },
        
        responsive : {
            
            0 : {
                items       : itemsOnMobile,
                slideBy     : slideOnMobile,
                margin      : marginMobile,
                stagePadding: paddingMobile
            },
            740 : {
                items       : itemsOnDesktop,
                slideBy     : slideOnDesktop,
                margin      : marginDesktop,
                stagePadding: paddingDesktop
            }
        }
    })
})

$v2 = $('.js-owl-carousel.carousel-advice').each(function(e) {
    var $slider         = $(this)
    var padding         = $slider.data('padding')
    var dragging        = $slider.data('nodrag') ? false : true
    var $sliderControls = $slider.parent().find('.js-slider-controls')
    var $navContainer   = $sliderControls.find('.js-slider-nav')
    var $dotsContainer  = $sliderControls.find('.js-slider-dots')
    var autosize        = $slider.data('autosize')
    var $maps           = $slider.find('.js-google-maps')
    // Mobile
    var itemsOnMobile = $slider.data('items-mobile')
    var slideOnMobile = $slider.data('slide-mobile')
    var marginMobile  = padding ? -20 : 40
    var paddingMobile = padding ? 20 : 0

    // Desktop
    var itemsOnDesktop = $slider.data('items-desktop')
    var slideOnDesktop = $slider.data('slide-desktop')
    var marginDesktop  = padding ? 70 : 40
    var paddingDesktop = padding ? 120 : 0

    
    
    var sliderStartPosition = $('#slider_slide_start').length > 0 ? $('#slider_slide_start').val() : 'URLHash'
    
    $w = $slider.owlCarousel({
        URLhashListener: true,
        startPosition  : sliderStartPosition,
        nav            : true,
        dots           : true,
        mouseDrag      : dragging,
        touchDrag      : dragging,
        navText        : '',
        navContainer   : $navContainer,
        dotsContainer  : $dotsContainer,
        // autoHeight     : true,
        onInitialized : function () {
            //changeProgressBar()
            autosize ? autoHeightSlider($slider) : null
            //shouldStretch()
        },
        onTranslated : function (e) {
            var currentStep = e.item.index + 1;
            var realStep = location.hash ? (typeof location.hash.match(/\d+/)[0] !== "undefined" ? location.hash.match(/\d+/)[0] : 1) : 1;
            //changeProgressBar();
            autosize ? autoHeightSlider($slider) : null;
            //shouldStretch();
            //hideErrorMsg($slider);

            if (currentStep == 1) {
                virtualPageURL = window.location.pathname;
            } else {
                virtualPageURL = window.location.pathname + "step-" + realStep + "/";
            }

             /* Pour empecher au maximum un double envoie de données provenant du meme step
            sur analytics (principalement provoque lors des derniere etapes) */

            // if (! (currentStep == lastCarousel)) {
            //     kinougarde_tracking({
            //         "event" : "VirtualPageview",
            //         "virtualPageURL" : virtualPageURL,
            //         "virtualPageTitle" : document.title + " - STEP " + realStep
            //     });
            // }
            // console.log((!(currentStep == lastCarousel)), "step-" + realStep);
            lastCarousel = currentStep; 
            
            /* ----------------------------------------------------  */

            if (googleMapsLoaded && $maps.length) {
                google.maps.event.trigger($maps.get(0), "resize")
            }

            // if ($slider.closest('.js-steps').length) {
            //     $('html, body').animate({
            //         scrollTop: $('html, body').offset().top
            //     }, 'slow');
            // }
        },
        onResized : function () {
            autosize ? autoHeightSlider($slider) : null
            //shouldStretch()
        },
        
        responsive : {
            
            0 : {
                items       : itemsOnMobile,
                slideBy     : slideOnMobile,
                margin      : marginMobile,
                stagePadding: paddingMobile
            },
            979 : {
                items       : itemsOnDesktop,
                slideBy     : slideOnDesktop,
                margin      : marginDesktop,
                stagePadding: paddingDesktop
            }
        }
    })
})


function dataLayerPush(id, step) {
    dataLayer.push({
        'event': 'formevent',
        'form_type': id,
        'form_step': step.toString()
    })
}


